<template>
  <div class="list-group">
    <div class="list-group-item">
      <h4>{{ $t("gs.getting_started") | capitalize }}</h4>
      <div class="list-group">
        <div class="list-group-item" :class="steps.step_1 ? '' : 'strike'">
          <div class="row">
            <div class="col">
              <div :class="steps.step_1 ? 'h1' : 'h3'">1</div>
            </div>
            <div class="col">{{ $t("gs.verify_email") | capitalize }}</div>
            <div class="col">
              <button
                type="button"
                class="btn btn-success"
                @click="sendEmail"
                v-if="steps.step_1"
              >
                {{ $t("gs.email_button") | capitalize }}
              </button>
            </div>
          </div>
        </div>
        <div class="list-group-item" :class="steps.step_2 ? '' : 'strike'">
          <div class="row">
            <div class="col">
              <div :class="!steps.step_1 && steps.step_2 ? 'h1' : 'h3'">2</div>
            </div>
            <div class="col">{{ $t("gs.set_address") | capitalize }}</div>
            <div class="col">
              <a
                type="button"
                class="btn btn-success"
                href="/profile"
                v-if="steps.step_2"
                >{{ $t("profile.profile") | capitalize }}</a
              >
            </div>
          </div>
        </div>
        <!--<div class="list-group-item" :class="steps.step_3 ? '' : 'strike'">
        <div class="row">
          <div class="col">
            <div :class="!steps.step_2 && steps.step_3 ? 'h1' : 'h3'">3</div>
          </div>
          <div class="col">{{ $t("gs.set_languages") | capitalize }}</div>
          <div class="col">
            <a
              type="button"
              class="btn btn-success"
              href="/profile"
              v-if="steps.step_3"
              >{{ $t("profile.profile") | capitalize }}</a
            >
          </div>
        </div>
      </div>-->
      </div>
      <div
        class="h1 text-center m-2"
        v-if="!steps.step_1 && !steps.step_2 && !steps.step_3"
      >
        {{ $t("gs.complete") | capitalize }}
      </div>
    </div>
  </div>
</template>
<script>
import { auth } from "@/firebase";
import { mapState } from "vuex";
export default {
  data() {
    return {
      steps: {
        step_1: true,
        step_2: true
        //step_3: true//for future
      }
    };
  },
  computed: {
    ...mapState(["userProfile"])
  },
  methods: {
    sendEmail() {
      const self = this;
      auth.currentUser
        .sendEmailVerification()
        .then(function(e) {
          console.log(e);
          self.flashMessage.show({
            status: "success",
            message: self.$options.filters.capitalize(
              self.$t("gs.email_verify")
            )
          });
        })
        .catch(function(err) {
          console.log(err);
          self.flashMessage.show({
            status: "error",
            message: self.$options.filters.capitalize(
              self.$t("gs.email_verify_error")
            )
          });
        });
    },
    checkSteps() {
      if (this.userProfile !== undefined) {
        const p = this.userProfile;
        this.steps.step_1 = !p.emailVerified;
        if (p.details) {
          if (p.details.address) {
            console.log(p.details.address);
            if (Object.keys(p.details.address).length === 0) {
              this.steps.step_2 = true;
            } else {
              this.steps.step_2 =
                p.details.address.address_1 == "" &&
                p.details.address.state == "" &&
                p.details.address.city == "" &&
                p.details.address.country == "" &&
                p.details.address.zip == "";
            }
            //this.steps.step_2 = Object.keys(p.details.address).length === 0;
          }
          //for future
          /*if (p.details.languages) {
            this.steps.step_3 = Object.keys(p.details.languages).length === 0;
          }*/
        }
        console.log("step 1", this.steps.step_1);
        console.log("step 2", this.steps.step_2);
        //console.log("step 3", this.steps.step_3);
      }
    }
  },
  mounted() {
    this.checkSteps();
  },
  watch: {
    userProfile() {
      this.checkSteps();
    }
  }
};
</script>
<style scoped>
.strike {
  text-decoration: line-through;
}
</style>
